import React from 'react';
import classNames from 'classnames';

import { LRUTGeneralInformation } from '../../../forms/lrut/lrutGeneralInformation';
import { concatClassNames, formatTime } from '../../../../utils/utilities';
import { APP_DATE_FORMAT } from '../../../../utils/constants';

import CustomSection from '../../custom-general/custom-section';
import classes from './style.module.scss';
import css from "../../../themed/pdf/pdf.module.scss";


interface GridProps {
	title: string;
	value?: string | number;
}

interface Props {
	generalInformation: LRUTGeneralInformation;
}

const Grid: React.FC<GridProps> = ({ title, value }) => {
	return (
		<div className="row">
			<div className={classNames([classes.generalInformationGridTitle, 'col-5'])}>
				{title}
			</div>
			<div className={classNames([classes.generalInformationGridValue, 'col'])}>
				{value ?? 'N/A'}
			</div>
		</div>
	);
};

const LRUTGeneralInformationPDF: React.FC<Props> = ({ generalInformation }) => {
	return (
		<CustomSection sectionTitle="General Information">
			<div className="p-1">
				<div className="container-fluid overflow-hidden">
					<div className={concatClassNames([classes.technologyIntroduction, 'row'])}>
						<div className={concatClassNames([classes.technologyIntroductionLabel, 'col-4'])}>
							Technology Introduction:
						</div>
						<div className={concatClassNames([classes.technologyIntroductionValue, 'col'])}>
							{generalInformation.technologyIntroduction}
						</div>
					</div>
				</div>

				<div className="container-fluid overflow-hidden mt-1">
					<div className="row">
						<div className="col">
							<Grid title='Inspection Date' value={formatTime(generalInformation.dateOfInspection, APP_DATE_FORMAT)} />
						</div>
						<div className="col">
							<Grid title='Material' value={generalInformation.material} />
						</div>
					</div>

					<div className="row">
						<div className="col">
							<Grid title='Nominal Thickness (mm)' value={generalInformation.nominalThickness} />
						</div>
						<div className="col">
							<Grid title='Corrosion Allowance (mm)' value={generalInformation.corrosionAllowance} />
						</div>
					</div>

					<div className="row">
						<div className="col">
							<Grid title='Outer Diameter (mm)' value={generalInformation.outerDiameter} />
						</div>
						<div className="col">
							<Grid title='Fluid or Type' value={generalInformation.fluidType} />
						</div>
					</div>
				</div>
				
				<table className={classNames([css["pdf-table"], 'mt-1'])}>
					<thead>
						<tr>
							<th colSpan={8}>Equipment Details</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td className={css["table-title-grid"]}>Instrument / Manufacturer</td>
							<td className={css["table-title-grid"]}>Modal</td>
							<td className={css["table-title-grid"]} rowSpan={2}>Equipment Serial Number</td>
							<td className={css["table-title-grid"]} rowSpan={2}>{generalInformation.equipmentSN}</td>
							<td className={css["table-title-grid"]} rowSpan={2}>Calibration Date</td>
							<td className={css["table-title-grid"]} rowSpan={2}>{formatTime(generalInformation.calibrationDueDate, APP_DATE_FORMAT)}</td>
							<td className={css["table-title-grid"]} rowSpan={2}>Cable Check</td>
							<td className={css["table-title-grid"]} rowSpan={2}>{generalInformation.cableCheck}</td>
						</tr>
						<tr>
							<td className={css["table-title-grid"]}>Guided Wave Technology</td>
							<td className={css["table-title-grid"]}>{generalInformation.guidedWaveTechnology}</td>
						</tr>
						<tr>
							<td className={css["table-title-grid"]}>Collar Size (inch)</td>
							<td className={css["table-title-grid"]}>{generalInformation.collarSize}</td>
							<td className={css["table-title-grid"]}>Collar Serial Number</td>
							<td className={css["table-title-grid"]} colSpan={5}>{generalInformation.collarSN}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</CustomSection>
	);
};

export default LRUTGeneralInformationPDF;
